//React and Packages
import * as React from "react";
import { observer, inject } from "mobx-react";
import * as moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { errorMessage, successMessage } from "../common/Toast";

//Custom Components and Functions
import { SelectGroup } from "../common/SimpleFormComponents";
import LoadingWidget from "../common/LoadingWidget";

//Store and Endpoints
import { HorseForSaleEndpoints } from "../../endpoints/HorseForSaleEndpoints";
import { ConfigurationStore } from "../../stores/ConfigurationStore";

//Model
import { HorseSale, ApprovedActiveStates } from "../../model/HorseForSale";

export interface PropsStores {
    horseForSaleEndpoints?: HorseForSaleEndpoints;
    configurationStore?: ConfigurationStore;
}
export interface PropsComponent {}
type Props = PropsStores & PropsComponent;

export interface StateComponent {
    loading: boolean;
}
export interface StateFields {
    selectedSaleId: number | null;
}
type State = StateComponent & StateFields;

@inject("horseForSaleEndpoints")
@inject("configurationStore")
@observer
export class EntryFeeInvoiceGeneration extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedSaleId: null,
            loading: false
        };
    }

    genetareAllEntryFeeInvoices = async () => {
        try {
            this.setState({ loading: true });
            await this.props.horseForSaleEndpoints!.generateEntryFeeInvoicesForSale(this.state.selectedSaleId!);
            successMessage(`Entry Fee Invoices have been successfully generated.`);
        } catch (error) {
            errorMessage(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const configurationStore = this.props.configurationStore;
        if (!configurationStore) {
            return <div />;
        }

        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active" aria-current="page">
                            Generate All Entry Fee Invoices
                        </li>
                    </ol>
                </nav>
                <div className="content">
                    <div className="row">
                        <div className="col-12">
                            <h1>Generate All Entry Fee Invoices</h1>
                            <div className="card shadow">
                                <div className="card-body">
                                    {this.state.loading && (
                                        <div className="row">
                                            <div className="col-12">
                                                <LoadingWidget />
                                            </div>
                                        </div>
                                    )}
                                    <div className="form-row">
                                        <div className="col-12">
                                            <div className="alert alert-info text-center">
                                                <strong>Note:</strong> All the owners of Appproved and Withdrawn horses for sale will have the
                                                invoices for the Entry Fee posted to their accounts. Horses Withdrawn Early are excluded from this
                                                operation.
                                                <br />
                                                <strong>
                                                    If an Entry Fee invoice has already been generated for a horse for sale, a new one will not be
                                                    generated again.
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 d-flex flex-row">
                                        <SelectGroup
                                            label="Select Sale"
                                            name="selectedSale"
                                            isRequired={true}
                                            className="flex-fill"
                                            disabled={false}
                                            value={this.state.selectedSaleId || ""}
                                            onChange={e => {
                                                const selectedSaleId = e.target.value !== "" ? parseInt(e.target.value, 10) : null;
                                                this.setState({ selectedSaleId });
                                            }}
                                        >
                                            <option value=""> - Unknown - </option>
                                            {configurationStore.horseSales
                                                .sort((a: HorseSale, b: HorseSale) => b.id - a.id)
                                                .map(sale => (
                                                    <option key={sale.id} value={sale.id}>
                                                        {sale.name}
                                                    </option>
                                                ))}
                                        </SelectGroup>
                                        <div className="ml-2 pt-4">
                                            <button
                                                className="btn btn-primary mt-2"
                                                onClick={this.genetareAllEntryFeeInvoices}
                                                disabled={!this.state.selectedSaleId || this.state.loading}
                                            >
                                                <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" /> Generate All Entry Fee Invoices
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/EntryFeeInvoiceGeneration.tsx